import React from 'react'
import Modal from '../../../common/modal'
import { useAtom } from 'jotai'
import { modalAtom } from '../../../common/jotaiState/globalStateAtoms'
import { CircularProgress, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import { CheckCircle, Pending } from '@mui/icons-material'
import { useTheme } from '@mui/material/styles'
const ListItem = ({ item,icon }) => {
	return(
  <TableRow>
    <TableCell sx={{fontSize:"15px"}}>{item.UserName}</TableCell>
    <TableCell >{item.icon}</TableCell>
  </TableRow>
)}
export default function LoaderModel(props) {
  const [, setModal] = useAtom(modalAtom)
  const { list } = props
	const theme = useTheme()
	const iconSx = { fontSize: '30px', color: theme.palette.primary.main }

  const statusIconMap = [<Pending sx={iconSx} />, <CircularProgress sx={iconSx} size={30} />, <CheckCircle sx={iconSx} />]
  return (
    <Modal headTxt={'Loading Userwise Collection for all Users'} width={'60%'} updateModal={setModal}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell sx={{fontSize:"15px"}}>User Name</TableCell>
            <TableCell sx={{fontSize:"15px"}}>Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {list.map((item,index) => (
            <ListItem key={"eiss2"+index} item={{...item,icon:statusIconMap[item.loaded]}}/>
          ))}
        </TableBody>
      </Table>
    </Modal>
  )
}
